import * as React from 'react';
import { Route} from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import CWSSearch from './components/CWSSearch';
import CWSRateSearch from './components/CWSRateSearch';
import ApplicationError from './components/ApplicationError';
import VersionChecker from './components/VersionChecker';
import '@progress/kendo-theme-default/dist/all.css';
import './custom.css'

export default () => (
    <VersionChecker>
    <ApplicationError>
        <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/cwssearch' component={CWSSearch} />
        <Route path='/cwsratesearch' component={CWSRateSearch} />
        </Layout>
        </ApplicationError>
    </VersionChecker>
);
